import {creates, hoistCmp} from '@xh/hoist/core';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import {widgetToolbar} from '../../../../cmp/widget/WidgetToolbar';
import {widgetToolbarSelect} from '../../../../cmp/widget/WidgetToolbarSelect';
import {TopTradingWidgetModel} from './TopTradingWidgetModel';
import {placeholder} from '@xh/hoist/cmp/layout';
import {Icon} from '@xh/hoist/icon';
import {useOnVisibleChange} from '@xh/hoist/utils/react';
import {widgetToolbarLabel} from '../../../../cmp/widget/WidgetToolbarLabel';

export const topTradingWidget = hoistCmp.factory({
    model: creates(TopTradingWidgetModel),
    render({model}) {
        const visibleRef = useOnVisibleChange(visible => (model.isVisible = visible));
        return panel({
            ref: visibleRef,
            item: model.type ? grid({agOptions: model.agOptions}) : placeholder(Icon.gear(), 'Configure'),
            bbar: bbar()
        });
    }
});

const bbar = hoistCmp.factory<TopTradingWidgetModel>(({model}) =>
    widgetToolbar({
        items: [
            widgetToolbarLabel('tickers'),
            widgetToolbarSelect({
                title: 'Count',
                options: [
                    {value: -1, label: 'Auto'},
                    {value: 5, label: 'top 5'},
                    {value: 10, label: 'top 10'},
                    {value: 25, label: 'top 15'},
                    {value: 50, label: 'top 20'}
                ],
                bind: 'count'
            }),
            widgetToolbarLabel('exchanges'),
            widgetToolbarSelect({
                title: 'Exchange',
                bind: 'exchange',
                options: [
                    {value: null, label: 'All'},
                    {value: 'NASDAQ', label: 'NASDAQ'},
                    {value: 'NYSE', label: 'NYSE'},
                    {value: 'AMEX', label: 'AMEX'}
                ]
            })
        ]
    })
);
